import { Component, Input } from '@angular/core'
import { Idle } from '@ng-idle/core'
import { BsModalRef } from 'ngx-bootstrap/modal'
import { ToastrService } from 'ngx-toastr'
import { BehaviorSubject } from 'rxjs'

@Component({
   selector: 'vc-upload-dbx-modal',
   templateUrl: './upload-dbx-modal.component.html',
   styleUrl: './upload-dbx-modal.component.scss',
   standalone: false,
})
export class VetcorUploadDbxModalComponent {
   sourceInputValue: string = ''
   displayModal = true
   pipelines = [
      {
         id: 1,
         label: 'Prices',
         pipelineName: 'PricingUpdate Import Records',
      },
      {
         id: 2,
         label: 'Cycle Import',
         pipelineName: 'PricingUpdateBatch Import',
      },
   ]
   selectedPipeline = this.pipelines[0]

   @Input() isSubmitting = new BehaviorSubject<{ source: string; pipeline: string }>({ source: '', pipeline: '' })

   constructor(private toastr: ToastrService, private bsModalRef: BsModalRef, private idle: Idle) {
      this.idle.onTimeout.subscribe(() => {
         this.onClose()
      })
   }

   onSetPipeline(pipeline: any) {
      this.selectedPipeline = pipeline
   }

   onClose(): void {
      this.bsModalRef.hide()
   }

   onSubmit() {
      if (this.sourceInputValue?.length === 0) {
         alert('Source must have a value')
      } else {
         this.isSubmitting.next({ source: this.sourceInputValue, pipeline: this.selectedPipeline.pipelineName })
      }
   }
}
